import { render, staticRenderFns } from "./custom-pay.vue?vue&type=template&id=45361eb4&scoped=true&lang=pug"
import script from "./custom-pay.vue?vue&type=script&lang=ts"
export * from "./custom-pay.vue?vue&type=script&lang=ts"
import style0 from "./custom-pay.vue?vue&type=style&index=0&id=45361eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45361eb4",
  null
  
)

export default component.exports